import { Component, OnInit } from '@angular/core';
import { DatabaseService } from '../services/database.service';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss'],
  standalone: false
})
export class HealthComponent implements OnInit {
  loading = false;
  error: string | null = null;
  rows: any[] = [];
  columns: string[] = [];
  hasPolled = false;
  polledAt: string | null = null;
  pollSuccess: boolean | null = null;
  pollError: string | null = null;

  recentRows: any[] = [];
  recentColumns: string[] = [];
  recentRowsFetchedAt: string | null = null;
  recentRowsError: string | null = null;

  constructor(private db: DatabaseService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;
    this.db.getEnacLastPull().subscribe({
      next: (res) => {
        this.hasPolled = !!res?.hasPolled;
        this.polledAt = res?.timestamp || res?.lastPoll?.polledAt || null;
        this.pollSuccess = res?.lastPoll?.success ?? null;
        this.pollError = res?.lastPoll?.error || null;

        // The backend wraps the actual ENAC rows in lastPoll.rows; fall back to other shapes just in case.
        const data = res?.lastPoll?.rows
          ?? (Array.isArray(res) ? res : (res?.data || res?.rows || res?.value || (res && !this.hasPolled ? [] : [res])));
        this.rows = Array.isArray(data) ? data : [data];
        this.columns = this.rows.length ? Object.keys(this.rows[0]) : [];

        // Live sample of the most recently updated ENAC rows, independent of the last poll match
        this.recentRows = Array.isArray(res?.recentRows) ? res.recentRows : [];
        this.recentColumns = this.recentRows.length ? Object.keys(this.recentRows[0]) : [];
        this.recentRowsFetchedAt = res?.recentRowsFetchedAt || null;
        this.recentRowsError = res?.recentRowsError || null;
      },
      error: (err) => {
        this.error = err?.message || 'Failed to load ENAC data';
      },
      complete: () => this.loading = false
    });
  }
}
